import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body"]
  static values = {
    defaultSort: String,
  }

  connect() {
    const initial = this.defaultSortValue || "account"
    this.sortBy(initial)
  }

  sort(event) {
    const key = event?.currentTarget?.dataset?.sortKey
    if (!key) return
    this.sortBy(key)
  }

  sortBy(key) {
    if (!this.hasBodyTarget) return

    const rows = Array.from(this.bodyTarget.querySelectorAll("tr"))
    const sorted = rows.sort((a, b) => this.compareRows(a, b, key))

    sorted.forEach((row) => this.bodyTarget.appendChild(row))
  }

  compareRows(a, b, key) {
    const orderA = this.numberValue(a.dataset.order, 0)
    const orderB = this.numberValue(b.dataset.order, 0)
    const amountA = this.numberValue(a.dataset.amount, null)
    const amountB = this.numberValue(b.dataset.amount, null)
    const accountA = (a.dataset.account || "").toLowerCase()
    const accountB = (b.dataset.account || "").toLowerCase()

    if (key === "order") {
      return orderA - orderB
    }

    if (key === "amount") {
      const amountCompare = this.compareNumberDesc(amountA, amountB)
      if (amountCompare !== 0) return amountCompare
      return orderA - orderB
    }

    if (key === "account") {
      const rankA = accountA === "cost of sales - food" ? 1 : 0
      const rankB = accountB === "cost of sales - food" ? 1 : 0
      if (rankA !== rankB) return rankA - rankB
      if (accountA !== accountB) return accountA.localeCompare(accountB)
      const amountCompare = this.compareNumberDesc(amountA, amountB)
      if (amountCompare !== 0) return amountCompare
      return orderA - orderB
    }

    return orderA - orderB
  }

  numberValue(value, fallback) {
    if (value === undefined || value === null || value === "") return fallback
    const num = Number(value)
    return Number.isFinite(num) ? num : fallback
  }

  compareNumberDesc(a, b) {
    const aMissing = a === null || a === undefined || Number.isNaN(a)
    const bMissing = b === null || b === undefined || Number.isNaN(b)
    if (aMissing && bMissing) return 0
    if (aMissing) return 1
    if (bMissing) return -1
    return b > a ? 1 : b < a ? -1 : 0
  }
}
